module.exports = __webpack_public_path__ + "static/img/score_bg.1cdc891.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/score_bg.png
// module id = 7m9x
// module chunks = 1